export enum BreadcrumbDataTestIdEnum {
  BREADCRUMB_CONTAINER = 'breadcrumb--container',
  BREADCRUMB_HOUSE_ICON_LINK = 'breadcrumb--house-icon-link',
  BREADCRUMB_OPTION = 'breadcrumb--option',
}
